import styled from 'styled-components';

export const ContentWrapper = styled.div`
  width: 100%;
  background-color: #ffffff;
  height: 70%;
  display: flex;
  flex-direction: column;
  padding: 24px;
  min-height: 500px;
`;

export const DataTableWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const StyledPara = styled.div`
  font-size: 14px;
`;

export const SummaryWrapper = styled.div`
  display: flex;
  width: 400px;
  justify-content: space-between;
  padding: 4px;
`;

export const SummaryColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const SummaryColumnHeader = styled.h3`
  color: #666;
  text-transform: capitalize;
`;

export const SummaryColumnValue = styled.h2`
  /* font-size: 14px; */
`;

export const PageTitle = styled.h1`
  padding: 0px;
`;
